<div class="blank-layout-container justify-content-center">
  <div class="row">
    <div class="col-12 text-center">
      <img src="/assets/images/logos/f4rm-logo-text.png" alt="error-bg" class="logolight" width="350" height="109"
        style="margin: 0 auto;" />
      <img src="/assets/images/logos/f4rm-logo-text-inverted.png" alt="error-bg" class="logodark" width="350"
        height="109" style="margin: 0 auto;" />
      @if (isAuthError()) {
        <h2 class="auth-title f-w-600">{{ 'exception.auth.title' | translate }}</h2>
        <h6 class="f-s-20 f-w-600 m-y-30">{{ 'exception.auth.content' | translate }}</h6>
        <app-mat3-button [text]="'exception.auth.retry' | translate" variant="primary"
          (buttonClick)="retryAuth()"></app-mat3-button>
      } @else {
        <h2 class="auth-title f-w-600">Oopps!!!</h2>
        <h6 class="f-s-20 f-w-600 m-y-30">{{ 'exception.content' | translate }}</h6>
        <app-mat3-button [text]="'exception.back' | translate" variant="primary" [routerLink]="['/']"></app-mat3-button>
      }
    </div>
  </div>
</div>